import { render } from "./PredictiveAnalytics.vue?vue&type=template&id=78ca4b48"
import script from "./PredictiveAnalytics.vue?vue&type=script&lang=js"
export * from "./PredictiveAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__